import { useState } from "react";
import { Link } from "react-router-dom";

const footerLinks = {
  "AI Services": [
    { label: "AI Business Consulting", path: "/services" },
    { label: "Agentic AI & Automation", path: "/services" },
    { label: "AI Chatbots & Assistants", path: "/services" },
    { label: "AI-Powered Websites", path: "/services" },
    { label: "Custom AI Software", path: "/services" },
    { label: "IT Training & Certification", path: "/academy" },
  ],
  Company: [
    { label: "About Us", path: "/about" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "CPI Academy", path: "/academy" },
    { label: "AI Readiness", path: "/ai-readiness" },
    { label: "Careers", path: "/about" },
    { label: "Contact", path: "/contact" },
  ],
  Resources: [
    { label: "Case Studies", path: "/portfolio" },
    { label: "AI Training Programs", path: "/academy" },
    { label: "AI Readiness Assessment", path: "/ai-readiness" },
    { label: "Book a Consultation", path: "/contact" },
    { label: "FAQ", path: "/contact" },
    { label: "Privacy Policy", path: "/" },
    { label: "Terms of Service", path: "/" },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  

  return (
    <footer className="bg-black text-white">
      {/* Top accent line */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-[#C8F135]/60 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-2">

            <p className="text-zinc-400 text-sm leading-relaxed mb-6 max-w-xs">
              Together, We Make AI Happen. Global AI &amp; technology consulting firm headquartered in Chicago, USA with offices in Lagos, Nigeria. Founded 1996.
            </p>
            <div className="flex items-center gap-3 mb-8">
              {[
                { icon: "ri-linkedin-fill", href: "#" },
                { icon: "ri-twitter-x-fill", href: "#" },
                { icon: "ri-github-fill", href: "#" },
                { icon: "ri-instagram-line", href: "#" },
              ].map((s) => (
                <a key={s.icon} href={s.href} rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-zinc-800 hover:bg-[#C8F135] hover:text-black transition-all cursor-pointer">
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
            
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-xs font-bold uppercase tracking-widest text-zinc-400 mb-5">
                <a id={`footer-${title.toLowerCase()}`}>{title}</a>
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="text-sm text-zinc-400 hover:text-[#C8F135] transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact Bar */}
        <div className="border-t border-zinc-800 pt-8 mb-8">
          <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-8 text-sm text-zinc-400">
            <a href="mailto:info@cpitechinc.com" className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer">
              <i className="ri-mail-line text-[#C8F135]" /> info@cpitechinc.com
            </a>
            <a href="tel:+12242018888" className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer">
              <i className="ri-phone-line text-[#C8F135]" /> +1 (224) 201-8888
            </a>
            <span className="flex items-center gap-2">
              <i className="ri-map-pin-line text-[#C8F135]" /> 1900 N Austin Ave, Suite 210, Chicago IL 60639
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-map-pin-2-line text-[#C8F135]" /> Lagos, Nigeria (Africa Hub)
            </span>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-500">&copy; {new Date().getFullYear()} CPI Technologies Inc. All rights reserved. &nbsp;·&nbsp; <span className="text-zinc-400 italic">Together, We Make AI Happen.</span></p>
          <div className="flex items-center gap-4 text-xs text-zinc-500">
            <a href="#" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <span className="text-zinc-700">|</span>
            <a href="#" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            <span className="text-zinc-700">|</span>
            <a href="#" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
